<template>
  <div class="profile py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Profile" active>
                <section class="login-page">
                  <div class="container">
                    <div class="login">
                      <h1 class="heading-title text-center">Profile Info</h1>
                      <div class="row align-items-center justify-content-center">
                        <div class="col-12">
                          <form>
                            <div class="form-row align-items-center justify-content-center">
                              <div class="form-group col-md-12">
                                <label for="name" class="required">Name</label>
                                <input
                                  type="text"
                                  class="form-control input"
                                  id="name"
                                  placeholder="Name"
                                  v-model="user.name"
                                />
                              </div>

                              <div class="form-group col-md-12">
                                <label class="required">phone</label>
                                <input
                                  type="text"
                                  class="form-control input"
                                  placeholder="phone"
                                  v-model="user.phone"
                                />
                              </div>

                              <div class="form-group col-md-12">
                                <label class="required">address</label>
                                <input
                                  type="text"
                                  class="form-control input"
                                  placeholder="address"
                                  v-model="user.address"
                                />
                              </div>
                              <div class="form-group col-md-12">
                                <label class="required">post code</label>
                                <input
                                  type="text"
                                  class="form-control input"
                                  placeholder="post code"
                                  v-model="user.postCode"
                                />
                              </div>

                              <div class="form-group col-12">
                                <button
                                  type="button"
                                  class="btn main-btn w-100"
                                  @click="saveData"
                                >Save Data</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </b-tab>
              <b-tab title="Account setting">
                <section class="login-page">
                  <div class="container">
                    <div class="login">
                      <h1 class="heading-title text-center">Account Seeting</h1>
                      <div class="row align-items-center justify-content-center">
                        <div class="col-12">
                          <form>
                            <div class="form-row align-items-center justify-content-center">
                              <div class="form-group col-md-12">
                                <label class="required">New Email</label>
                                <input
                                  type="email"
                                  class="form-control input"
                                  placeholder="New Email"
                                  v-model="updatedUser.email"
                                />
                              </div>

                              <div class="form-group col-md-12">
                                <label class="required">New Password</label>
                                <input
                                  type="password"
                                  class="form-control input"
                                  placeholder="New Password"
                                  v-model="updatedUser.password"
                                />
                              </div>

                              <div class="form-group col-12">
                                <button
                                  type="button"
                                  class="btn main-btn w-100"
                                  @click="changeAccountData"
                                >Save Data</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { firestore } from "../../firebase";
// import fb from "../../firebase";
export default {
  name: "profile",
  data() {
    return {
      user: {
        name: null,
        phone: null,
        address: null,
        postCode: null
      },
      updatedUser: {
        email: '',
        password: ''
      }
    };
  },
  computed: {
    userData() {
      return this.$store.getters["authModule/getUserData"];
    },
    userId() {
      return this.$store.getters["authModule/getUser"].id;
    }
  },
  firestore() {
    return {
      user: firestore.collection("users").doc(this.userId)
    };
  },
  methods: {
    saveData() {
      this.$firestore.user.update(this.user).then(() => {
        // console.log("updated successfully");
      });
    },
    changeAccountData() {
      if(this.updatedUser.email && this.updatedUser.password) {
        this.$store.dispatch("authModule/changeUserEmailAndPassword", this.updatedUser);
      }
    }
  }
};
</script>